import { useCallback, useEffect, useState } from "react";
import Loader from "../../../components/loader";
import { AiFillStar, AiOutlineDelete, AiOutlineStar } from "react-icons/ai";
import { Button, Card, Empty, Input, Modal, Popover } from "antd";
import { useNavigate } from "react-router";
import SendMoneyService from "../../../services/send-money.service";
import { BsThreeDotsVertical } from "react-icons/bs";
import { useSelector } from "react-redux";
import { modeSelector } from "../../../store/selectors/app.selector";
import { ReactComponent as TickIcon } from "../../../assests/images/tickIcon.svg";
import { ReactComponent as AddIcon } from "../../../assests/images/Add.svg";
import defaultUser from "../../../assests/images/defaultuser.svg";
import { amountFormat } from "../../../services/common.service";
import { useTranslation } from "react-i18next";

export default function InternationalPayeeList() {
  const [noRecords, setNoRecords] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [loader, setLoader] = useState(false);
  const [searchLoader, setSearchLoader] = useState(false);
  const [message, setMessage] = useState("");
  const [visible, setVisible] = useState(false);
  const mode = useSelector(modeSelector);
  const [favType, setFavType] = useState("");
  const [searchText, setSearchText] = useState("");
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [editVisible, setEditVisible] = useState(false);
  const { t } = useTranslation();
  const [payeeImage, setPayeeImage] = useState("");

  useEffect(() => {
    setLoader(true);
    getAllPayee("");
  }, []);

  const getAllPayee = useCallback(async () => {
    try {
      const response = await SendMoneyService.getAllPayee({
        mode: mode,
      });
      if (response.status === 200) {
        setLoader(false);
        setSearchLoader(false);
        setDataSource(response.data["data"]["internationalBeneList"]);
        setList(response.data["data"]["internationalBeneList"]);
        setNoRecords(
          response.data["data"]["internationalBeneList"].length > 0
            ? false
            : true
        );
      }
    } catch (error) {
      setLoader(false);
      setSearchLoader(false);
      setNoRecords(true);
    }
  }, []);

  const getPayeeImages = useCallback(async () => {
    try {
      const req = {
        mode: mode,
        accNo: dataSource.map((e) => e.beneAccNo),
      };
      const response = await SendMoneyService.getPayeeImages(req);
      if (response.status === 200) {
        setPayeeImage(response.data["data"]["imagesList"]);
      }
    } catch (error) {}
  }, [dataSource]);

  useEffect(() => {
    if (dataSource.length > 0) {
      getPayeeImages();
    }
  }, [dataSource, getPayeeImages]);

  const addFavouritePayee = useCallback(async (option) => {
    try {
      setFavType(option?.favorites === "N" ? "Y" : "N");
      const response = await SendMoneyService.addFavouritePayee({
        reqId: option?.reqId,
        favorites: option?.favorites === "N" ? "Y" : "N",
        mode: mode,
        beneType: "INTERNATIONAL",
      });
      if (response.status === 200) {
        // setDataSource([]);
        // getAllPayee();
        setMessage(response.data["message"]);
        setVisible(true);
      }
    } catch (error) {}
  }, []);

  const onSearch = (item) => {
    setSearchLoader(true);
    setSearchText(item);
    const transformToLower = item.toLowerCase();
    let filteredData = list.filter(function (item) {
      const beneNickName = item.beneNickName.toLowerCase();
      return beneNickName.includes(transformToLower);
    });

    if (filteredData.length === 0) {
      setDataSource([]);
      setSearchLoader(false);
      setNoRecords(true);
    } else {
      setDataSource(filteredData);
      setSearchLoader(false);
      setNoRecords(false);
    }
  };

  return (
    <>
      <div className="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
        <Card
          className="transfercard mb-2 application-card"
          align="center"
          onClick={() => navigate("/add-international-beneficary")}
        >
          <div className="mt-2">
            <AddIcon height={30} />
          </div>
          <div className="mt-2">
            <span
              style={{
                fontSize: "12px",
                fontWeight: 600,
              }}
            >
              {t("pages.Add_Bene.add_new", {
                defaultValue: "Add New",
              })}
            </span>
          </div>
        </Card>
      </div>
      {dataSource.map((option, idx) => (
        <div
          key={idx}
          className="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2"
        >
          <Card
            className="transfercard mb-3"
            align="center"
            onClick={() => {
              setEditVisible(true);
              setSelectedOption(option);
            }}
          >
            <div className="mt-2">
              {payeeImage.length > 0 ? (
                payeeImage.map((image, index) =>
                  image.beneAccNo === option.beneAccNo ? (
                    <img
                      key={index}
                      src={image?.imageData}
                      alt={option.beneNickName}
                      height={30}
                    />
                  ) : null
                )
              ) : (
                <img
                  key="default"
                  src={defaultUser}
                  alt={option.beneNickName}
                  height={30}
                />
              )}
              {payeeImage.length > 0 &&
                !payeeImage.some(
                  (image) => image.beneAccNo === option.beneAccNo
                ) && (
                  <img
                    key="default"
                    src={defaultUser}
                    alt={option.beneNickName}
                    height={30}
                  />
                )}
            </div>
            <div className="mt-2">
              <span
                style={{
                  fontSize: "12px",
                  fontWeight: 600,
                }}
                className="transfercardspan"
                title={option?.beneNickName || "-"}
              >
                {option.beneNickName || "-"}
              </span>
            </div>
          </Card>
        </div>
      ))}

      <Modal
        open={visible}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
        className="custom-error-modal"
      >
        <div style={{ margin: "0 auto" }} align="center">
          <TickIcon height={65} />
          <h4 className="mb-3 mt-2">
            {" "}
            {t("common.success", {
              defaultValue: "Success",
            })}
          </h4>
          <p>{message}</p>

          <div align="center">
            <Button
              size="large"
              style={{ width: 130 }}
              onClick={() => {
                setVisible(false);
                getAllPayee();
              }}
              type="primary"
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        open={editVisible}
        footer={null}
        width={800}
        closable={true}
        maskClosable={false}
        mask={true}
        className="custom-error-modal"
        onCancel={() => setEditVisible(false)}
      >
        <div className="row profile-details">
          {/* <div className="col-12 col-sm-12 col-md-6 col-lg-3" align="center">
            {payeeImage !== null && payeeImage?.length > 0 ? (
              <img
                src={payeeImage}
                alt="Profile"
                height={130}
                width={130}
                style={{ backgroundColor: "#108ee9" }}
              />
            ) : (
              <img src={profileIcon} alt="Profile" height={130} />
            )}
          </div> */}
          <div
            className="col-12 col-sm-12 col-md-12 col-lg-12"
            style={{ marginLeft: "20px" }}
          >
            <div className="row">
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 mb-3 mt-3">
                <label>
                  {t("pages.Add_Bene.bane_name", {
                    defaultValue: "Beneficiary Name",
                  })}{" "}
                </label>
                <span>{selectedOption?.beneName || "-"}</span>
              </div>

              <div className="col-12 col-sm-12 col-md-6 col-lg-6 mb-3 mt-3">
                <label>
                  {t("pages.Add_Bene.bene_nick_name", {
                    defaultValue: "Beneficiary Nick Name",
                  })}
                </label>
                <span>{selectedOption?.beneNickName || "-"}</span>
              </div>

              <div className="col-12 col-sm-12 col-md-6 col-lg-6 mb-3">
                <label>
                  {t("common.account_no_lbl", {
                    defaultValue: "Account Number",
                  })}
                </label>
                <span> {selectedOption?.beneAccNo || "-"}</span>
              </div>

              <div className="col-12 col-sm-12 col-md-6 col-lg-6 mb-3 ">
                <label>
                  {t("pages.payment_history.mode_transfer", {
                    defaultValue: "Mode of Transfer",
                  })}
                </label>
                <span>
                  {selectedOption?.modeOfTransfer === "ROUTE"
                    ? t("pages.Add_Bene.routing_number", {
                        defaultValue: "Routing Number",
                      })
                    : selectedOption?.modeOfTransfer === "IFSC"
                    ? t("pages.Add_Bene.ifsc_code", {
                        defaultValue: "IFSC Code",
                      })
                    : t("pages.Add_Bene.swift_or_bic", {
                        defaultValue: "Swift / BIC Code",
                      })}
                </span>
              </div>

              <div className="col-12 col-sm-12 col-md-6 col-lg-6 mb-3 ">
                <label>
                  {selectedOption?.modeOfTransfer === "ROUTE"
                    ? t("pages.Add_Bene.routing_number", {
                        defaultValue: "Routing Number",
                      })
                    : selectedOption?.modeOfTransfer === "IFSC"
                    ? t("pages.Add_Bene.ifsc_code", {
                        defaultValue: "IFSC Code",
                      })
                    : t("pages.Add_Bene.swift_or_bic", {
                        defaultValue: "Swift / BIC Code",
                      })}
                </label>
                <span>{selectedOption?.swiftCode || "-"}</span>
              </div>

              <div className="col-12 col-sm-12 col-md-6 col-lg-6 mb-3 ">
                <label>
                  {t("common.bank_name", {
                    defaultValue: "Bank Name",
                  })}
                </label>
                <span>{selectedOption?.bankName || "-"}</span>
              </div>

              <div className="col-12 col-sm-12 col-md-6 col-lg-6 mb-3 ">
                <label>
                  {" "}
                  {t("pages.Add_Bene.bank_country", {
                    defaultValue: "Bank Country",
                  })}
                </label>
                <span>{selectedOption?.bankCountry || "-"}</span>
              </div>

              <div className="col-12 col-sm-12 col-md-6 col-lg-6 mb-3 ">
                <label>
                  {" "}
                  {t("pages.Add_Bene.bank_address", {
                    defaultValue: "Bank Address",
                  })}
                </label>
                <span>{selectedOption?.bankAddress || "-"}</span>
              </div>

              <div className="col-12 col-sm-12 col-md-6 col-lg-6 mb-3 ">
                <label>
                  {" "}
                  {t("pages.Add_Bene.bene_currency", {
                    defaultValue: "Beneficiary Currency",
                  })}
                </label>
                <span>{selectedOption?.beneCurrency || "-"}</span>
              </div>

              {/* <div className="col-12 col-sm-12 col-md-6 col-lg-6 mb-3 ">
                <label>Beneficiary Email</label>
                <span>{selectedOption?.beneEmail || "-"}</span>
              </div>

              <div className="col-12 col-sm-12 col-md-6 col-lg-6 mb-3 ">
                <label>Beneficiary Mobile Number</label>
                <span>{selectedOption?.beneMobileNo || "-"}</span>
              </div> */}

              <div className="col-12 col-sm-12 col-md-6 col-lg-6 mb-3 ">
                <label>
                  {t("pages.transfer_limit.transfer_limit", {
                    defaultValue: "Transfer Limit",
                  })}
                </label>
                <span>
                  {amountFormat(
                    selectedOption?.maxTransferLimit,
                    selectedOption?.beneCurrency
                  )}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="manage-bene-btn-group">
          <Button
            className="secondary-btn mx-5"
            onClick={() =>
              navigate(
                "/beneficiary-management/international-beneficiary-details",
                {
                  state: { ...selectedOption, type: "VIEW" },
                }
              )
            }
            size="large"
          >
            {t("pages.Add_Bene.modify_beneficiary", {
              defaultValue: "Modify Beneficiary",
            })}
          </Button>
          <Button
            type="primary"
            className="primary-btn mt-2"
            onClick={() =>
              navigate("/send-money/payee-transfer", {
                state: { ...selectedOption, mode: "PAY_LIST" },
              })
            }
            size="large"
          >
            {t("pages.Add_Bene.make_payment", {
              defaultValue: "Make Payment",
            })}
          </Button>
        </div>
      </Modal>
    </>
  );
}
